import { useCallback } from 'react';

import { useQuery } from '@tanstack/react-query';

import { sort } from '@hsp/utilities';

import { globalQueryKeys } from 'hooks/queries/query-keys';
import { lookupService } from 'services';
import { IDataContainer, IResult } from 'types/api/common';
import { IState } from 'types/api/states';

export const useFetchStates = () => {
  return useQuery({
    queryFn: async () => {
      return await lookupService.getStates();
    },
    queryKey: globalQueryKeys.states,
    select: useCallback((data: IResult<IDataContainer<IState[]>> | undefined) => {
      const states = data?.dataContainer?.data ?? [];

      sort(states, { field: 'name' });

      return states;
    }, []),
  });
};
